import { computed, ref } from 'vue-demi';
import creativeState from './../../store/modules/ads_creative/index';
import {
  clearError,
  setCurCta,
  setCurURL,
  setError,
  setImageUrl,
  setTitle,
  title,
  setCurAdGroupName,
} from './state';
import { MaterialSource } from './../../const/media';
import i18n from './../../i18n';
import emoji from 'emoji-regex';
import { textForbiddenChar } from './../../store/modules/verify/index';
import { TTCallToAction } from './../../const/creative';
import store from './../../store/index';
import { getAttachParams } from './../../hooks/tt4b/index';
import { getLang } from './../../utils/unicodeUtil';
import teaTracker from './../../tea-tracker';
import { TEA_EVENT } from './../../const/state/TeaNames';
import { useObjectiveHooks } from './../../hooks/creation/objective/objectiveStatus';
import identityStore from './../../store/modules/identity/index';
import { checkURLHasPrefixOnly } from './../../utils/tool';
import { checkURLPrefix, strongUrlValidation, checkUrlLength } from './../../utils/tt4b/index';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useState() {
  const { isLead, isEngagement, isTraffic, isReach, isVideoView } = useObjectiveHooks();
  const displayNameInvalid = ref(false);
  const creationForm = ref();
  const objective = computed(() => creativeState.getters.campaignFormData.value.objectiveType);
  const activeSource = computed(() => creativeState.state.identity.activeSource.value);
  const creative = computed(() => creativeState.getters.creativeFormData.value);
  const isLoadingVideo = computed(() => creativeState.getters.general.value.isCreatingVideo);
  const identity = computed(() => creativeState.getters.identityFormData.value);
  const identityList = computed(() => creativeState.getters.identityFormData.value.identityList);
  const ownedTikTokAccount = computed(() => creativeState.getters.identityFormData.value.ownedTikTokAccount);
  const isFromCreation = computed(() => creativeState.getters.campaignFormData.value.fromCreation);
  const selectedVideo = computed(() => creativeState.state.identity.selectedVideo.value);
  const creativeInfo = computed(() => creativeState.state.identity.creativeInfo.value);
  const leadGenIframe = computed(() => creativeState.getters.creativeFormData.value.instantForm);
  const stage = computed(() => creativeState.state.creative.videoStage.value);
  const aadvid = computed(() => store.state?.account?.accountInfo?.id || '');
  const lockedIdentity = computed(() => creativeState.getters.notAllowSwitchAccount.value);
  const ifAtInitVideoStage = computed(() => creativeState.getters.creativeFormData.value.initVideoStage);
  const userHasOwnedTikTokAccount = computed(() => creativeState.getters.userHasOwnedTikTokAccount.value);
  const tiktokIdentityAvatarUrl = computed(
    () =>
      identity.value.curIdentity?.avatar_icon?.url ||
      'https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/ads_manager/mobile_lite/20230627-113302.jpeg',
  );
  const tiktokIdentityDisplayName = computed(() => identity.value.curIdentity?.display_name || '');
  const useTiktokVideo = computed(() => activeSource.value === MaterialSource.TIKTOK_VIDEO);
  const fakeIdentityObject = ref({
    avatarIcon: identity.value.imageInfo,
    displayName: identity.value.displayName,
  });
  const accountInfo = computed(() => store.state.account.accountInfo);
  const ctaOptions = computed(() => TTCallToAction);
  const videoData = computed(() => {
    if (activeSource.value === -1) {
      return {};
    }
    const allInfo = {
      [MaterialSource.TIKTOK_VIDEO]: selectedVideo?.value?.video_info,
      [MaterialSource.LIBRARY]: creativeInfo?.value,
      [MaterialSource.CAMERA_ROLL]: creativeInfo.value,
    };
    const info = allInfo?.[activeSource.value];
    if (info) {
      creativeState.mutations.setCreatingVideoStatus(false);
      return {
        loading: true,
        type: 'video',
        vid: info.vid,
        width: info.width,
        height: info.height,
        duration: info.duration,
        posterUrl: info.cover_url,
        playUrl: info?.main_url ? atob(info?.main_url) : info.play_url,
        validateResult: {},
      };
    }
    return {};
  });
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const titleValidator = (rule, value, callback) => {
    const ifTikTokPost = computed(() => activeSource.value === MaterialSource.TIKTOK_VIDEO);
    const len = title.value.length;
    if (ifTikTokPost.value) {
      return true;
    }
    if (len > 100) {
      setError({ key: 'title' });
      callback(i18n.t('module_fastcreation_creative_text_toolong'));
    } else if (len < 1) {
      // TODO: module_fastcreation_creative_text_tooshort需要修改
      setError({ key: 'title' });
      callback(i18n.t('module_fastcreation_creative_text_tooshort'));
    } else if (emoji().test(value)) {
      setError({ key: 'title' });
      callback(i18n.t('module_fastcreation_creative_text_emoji'));
    } else if (textForbiddenChar.test(value)) {
      setError({ key: 'title' });
      callback(i18n.t('module_fastcreation_creative_text_character'));
    } else {
      clearError('title');
      callback();
    }
  };
  // 校验externalUrl合法性
  const validateLink = (rule, value, callback): any => {
    const url = creativeState.state.creative.curURL.value;
    console.log('🚀 ~ validateLink ~ url:', url);
    if (!url) {
      return callback({
        message: i18n.t('module_adgroup_external_url_empty'),
        messageI18nKey: 'module_adgroup_external_url_empty',
      });
    }
    if (!checkURLPrefix(url)) {
      return callback({
        message: i18n.t('module_fastcreation_popup_promotelink_hint3'),
        messageI18nKey: 'module_fastcreation_popup_promotelink_hint3',
      });
    } else if (!strongUrlValidation(url) || !checkUrlLength(url)) {
      return callback({
        message: i18n.t('module_adgroup_external_url_error'),
        messageI18nKey: 'module_adgroup_external_url_error',
      });
    }
    // if (!url || (!url?.startsWith('https://') && !url?.startsWith('http://'))) {
    //   return callback({
    //     message: i18n.t('module_fastcreation_popup_promotelink_hint1'),
    //     messageI18nKey: 'module_fastcreation_popup_promotelink_hint1',
    //   });
    // } else if (checkURLHasPrefixOnly(url)) {
    //   return callback({
    //     message: i18n.t('module_fastcreation_popup_promotelink_hint3'),
    //     messageI18nKey: 'module_fastcreation_popup_promotelink_hint3',
    //   });
    // }
    return callback();
  };
  const validateAdGroupName = (rule, value, callback) => {
    const adGroupName = creativeState.state.creative.curAdGroupName.value;
    console.log('🚀 ~ validateAdGroupName ~ adGroupName:', adGroupName);
    if (!adGroupName) {
      return callback({
        message: i18n.t('module_creative_identity_enter_display_name_placeholder'),
        messageI18nKey: 'module_creative_identity_enter_display_name_placeholder',
      });
    }
    return callback();
  };
  const validators = {
    callToAction: [
      {
        trigger: 'change',
        validator: (_rule, value, callback): any => {
          if (!value) {
            return callback({
              message: i18n.t('ad_call_to_action_hint'),
              messageI18nKey: 'ad_call_to_action_hint',
            });
          }

          return callback();
        },
      },
    ],
    title: [
      {
        trigger: 'blur',
        validator: titleValidator,
      },
    ],
    externalUrl: [
      {
        trigger: 'blur',
        validator: validateLink,
      },
    ],
    adGroupName: [
      {
        trigger: 'blur',
        validator: validateAdGroupName,
      },
    ],
  };
  const handleOnChange = (e): void => {
    setTitle(e);
  };
  const updateCta = (cta): void => {
    setCurCta(cta);
  };
  const updateURL = (url): void => {
    if (!url) {
      setCurURL('');
      return;
    }
    setCurURL(url);
  };
  const updateAdGroupName = (name): void => {
    if (!name) {
      setCurAdGroupName('');
      return;
    }
    setCurAdGroupName(name);
  };
  const updateURLWithHeader = (event) => {
    const url = event.target.value.trim();
    if (!url) {
      setCurURL('');
    }

    if (!url.startsWith('https://') && !url.startsWith('http://')) {
      setCurURL(`https://${url}`);
      return;
    }
    setCurURL(url);
  };
  const useCustomCreateAvatarProps = computed(() => {
    const aadvid = computed(() => store.state?.account?.accountInfo?.id || '');
    const headers = {
      'X-CSRFToken': Cookies.get('csrftoken'),
    };
    const action = `/api/v3/i18n/tools/upload_image/?aadvid=${aadvid.value}`;
    const pureAction = '/api/v3/i18n/tools/upload_image/';
    return {
      pureAction,
      headers,
      action,
    };
  });
  const handleCroppedImage = (data): void => {
    const choppedImage = data.detail;
    if (choppedImage) {
      const { url = '', uri = '', image_info = {} } = choppedImage;
      setImageUrl(url);
      identityStore.mutations.setLocalAvatarIcon({
        width: image_info.width,
        height: image_info.height,
        web_uri: uri,
        url,
      });
      identityStore.mutations.setAvatarIcon({
        width: image_info.width,
        height: image_info.height,
        web_uri: uri,
        url,
      });
      teaTracker.trackEvent(TEA_EVENT.USER_UPLOAD_AVATAR, {
        objective_type: objective.value,
      });
    }
  };
  const handleAdName = (event): void => {
    const name = event?.detail?.detail;
    displayNameInvalid.value = name.length === 0;
    identityStore.mutations.setLocalDisplayName(name);
    identityStore.mutations.setDisplayName(name);
  };
  const config = computed(() => ({
    apps: creativeState.getters.audienceFormData.value.placement,
    info: {
      name: !useTiktokVideo.value
        ? creativeState.state.identity.displayName.value
        : creativeState.state.identity.selectedVideo?.value.nick_name,
      avatar: !useTiktokVideo.value
        ? creativeState.state.identity.imageInfo.value?.url
        : creativeState.state.identity.selectedVideo?.value?.avatar_icon?.url || '',
    },
    material: {
      type: 'video',
      media: videoData.value,
      label: !useTiktokVideo.value
        ? creativeState.state.creative.title.value
        : creativeState.state.identity.selectedVideo?.value.text,
      actionLabel: i18n.t(creativeState.state.creative.curCtaLabel.value),
    },
    additionalInfo: {
      instantPagePreviewUrl: '',
      additionalIframeQuery: getAttachParams(),
    },
    otherInfo: {
      lang: getLang(),
      isLoading: [1, 2].includes(creativeState.state.creative.videoStage.value),
      aadvid: aadvid.value,
      adType: 2,
      isNative: false,
      pangleIframeData: {
        adType: 2,
        isUnderNormalNativeAd: true,
        creativeFormData: {
          adType: 2,
        },
      },
    },
  }));
  return {
    stage,
    isLead,
    config,
    creative,
    updateCta,
    updateURL,
    updateURLWithHeader,
    isTraffic,
    isReach,
    isVideoView,
    objective,
    validators,
    identity,
    lockedIdentity,
    userHasOwnedTikTokAccount,
    ctaOptions,
    useTiktokVideo,
    identityList,
    isEngagement,
    accountInfo,
    creationForm,
    handleAdName,
    isFromCreation,
    leadGenIframe,
    handleOnChange,
    isLoadingVideo,
    ifAtInitVideoStage,
    handleCroppedImage,
    ownedTikTokAccount,
    fakeIdentityObject,
    displayNameInvalid,
    tiktokIdentityAvatarUrl,
    tiktokIdentityDisplayName,
    updateAdGroupName,
  };
}
